<div class="">
  <p-menubar [model]="menuItems" *ngIf="isAuthenticated">
    <ng-template pTemplate="item" let-item>
      <ng-container *ngIf="item.route; else noLink">
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          class="p-menuitem-link radius-8 p-l-20 p-r-20 p-t-8 p-b-8 trans-0-5 b2"
        >
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </ng-container>
      <ng-template #noLink>
        <div
          class="p-menuitem-link p-t-0 p-b-0 p-l-0 b2"
          [ngClass]="{
            toDoList: item.label == 'To - Do' && isToDoRoute,
            wpList: item.label == 'Work Packages' && isWorkPackageRoute
          }"
        >
          <span class="radius-8 p-l-20 p-r-20 p-t-8 p-b-8 trans-0-5 ml-2 b2">{{
            item.label
          }}</span>
          <span
            ><ng-icon class="b2" name="hugeArrowDown01" size="1.2em"></ng-icon
          ></span>
        </div>
      </ng-template>
    </ng-template>
    <ng-template pTemplate="start">
      <a class="navbar-brand" href="#">
        <img
          src="{{ env.assetUrl }}/logo.png"
          class=""
          alt="logo"
          loading="lazy"
        />
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <!-- <div>
        <a
          class="notification-icon trans-0-5 me-4 b2"
          href="#"
          *ngIf="!isNewNotification"
        >
          <ng-icon name="hugeNotification02"></ng-icon>
        </a>
        <a
          class="notification-icon trans-0-5 me-4 b2 p-badge-dot pos-relative"
          pBadge
          severity="success"
          href="#"
          *ngIf="isNewNotification"
        >
          <ng-icon name="hugeNotification02"></ng-icon>
        </a>
      </div>
      <div>
        <a class="faq-icon trans-0-5 me-4 b2" href="#">
          <ng-icon name="hugeBubbleChatQuestion"></ng-icon>
        </a>
      </div> -->
      <div
        class="d-flex align-items-center header-avatar-wrapper"
        tooltipClass="white-space-pre-line" placement="left" triggers="hover"
        ngbTooltip="{{
          this.loggedInUser.userData.name +
            '\n' +
            this.loggedInUser.userData.designation
        }}"
      >
        <p-button class="header-avatar-btn" [ngbPopover]="headerSubMenu">
          <p-avatar
            [image]="profilePic || helper.defaultImageUrl"
            value="4"
            size="large"
            class="me-2 text-left p-avatar-square"
          />
          <div class="me-2 wd-100px">
            <div
              class="b3 font-medium text-start of-hidden text-overflow space-nowrap"
            >
              {{ loggedInUser.userData.name }}
            </div>
            <div class="caption of-hidden text-overflow space-nowrap text-left">
              {{ loggedInUser.userData.designation }}
            </div>
          </div>
          <ng-icon
            class="avatar-arrow-down"
            name="hugeArrowDown01"
            size="1.2em"
            color="#121619"
          ></ng-icon>
        </p-button>

        <ng-template #headerSubMenu>
          <div class="header-avatar-menu">
            <a
              type="button"
              class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4 border-bottom-20"
              (click)="openDialog()"
            >
              <ng-icon class="text-80 lh-1-0" name="hugeImage01" size="18" />
              <span class="b2 text-80 m-l-10">Edit Profile Picture</span>
            </a>
            <div
              class="dis-flex flex-col p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
            >
              <label class="b2 text-80 m-b-10">Choose your role</label>
              <ng-container *ngFor="let category of categories">
                @if(this.userInfo['roles'][category.name| lowercase]) {
                <div class="field-checkbox m-l-10 m-b-10">
                  <p-radioButton
                    [inputId]="category.key"
                    name="category"
                    [value]="category"
                    [(ngModel)]="selectedCategory"
                    (click)="selectDesignation(category)"
                  />
                  <label [for]="category.key" class="m-l-8">
                    {{ category.name }}
                  </label>
                </div>
                }
              </ng-container>
              <div class="field-checkbox m-l-10 m-b-10">
                <p-radioButton
                  [inputId]="categories[4]['key']"
                  name="category"
                  [value]="categories[4]"
                  [(ngModel)]="selectedCategory"
                  (click)="selectDesignation(categories[4])"
                />
                <label [for]="categories[4]['key']" class="m-l-8">
                  {{ categories[4]["name"] }}
                </label>
              </div>
            </div>
            <a
              type="button"
              class="dis-flex danger-action-item p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4 border-top-20"
            >
              <ng-icon
                class="text-error lh-1-0"
                name="hugeLogout03"
                size="18"
              />
              <span class="b2 text-error m-l-10" (click)="logOut()"
                >Sign Out</span
              >
            </a>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </p-menubar>

  <p-menubar *ngIf="!isAuthenticated">
    <ng-template pTemplate="start">
      <a class="navbar-brand" href="#">
        <img
          src="{{ env.assetUrl }}/logo.png"
          class=""
          alt="logo"
          loading="lazy"
        />
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <div>
        <a class="me-4" href="#">
          <ng-icon name="hugeBubbleChatQuestion"></ng-icon>
        </a>
      </div>
    </ng-template>
  </p-menubar>
  <p-toast></p-toast>
</div>

<p-dialog
  [(visible)]="isEditProfile"
  class="edit-profile-picture-modal"
  header="Edit Profile Picture"
  [modal]="true"
  [style]="{ width: '30vw' }"
>
  <div class="text-center m-t-30">
    <div class="avatar-wrapper cursor-pointer" (click)="triggerFileInput()">
      <p-avatar
        [image]="uplodedProfilePic || undefined"
        [label]="!uplodedProfilePic ? 'U' : ''"
        size="xlarge"
        class="p-avatar-square"
        styleClass="profile-avatar"
      ></p-avatar>
      <ng-icon name="hugeEdit02" size="18" class="edit-icon"></ng-icon>
    </div>

    <!-- Hidden File Input -->
    <input
      type="file"
      #fileInput
      accept="image/*"
      (change)="onFileChange($event)"
      class="dis-none"
    />

    <div class="dis-flex m-t-60 flex-r">
      <button class="btn outline wd-100px m-r-10" (click)="closeDialog(fileInput)">Cancel</button>
      <button class="btn primary wd-100px" (click)="saveChanges()">Save</button>
    </div>
  </div>
</p-dialog>
